import { Injectable, inject, signal } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { appleAuthConfig } from '../services/apple.config'
import { NgxAppleLoginService } from 'ngx-apple-login';
import { AccountService } from './account';
import { HistoryEventService } from './history.event.service';
import { AuthSourceApple } from '../const/AuthConst'
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root',
})

export class AuthAppleService {
  private accountService = inject(AccountService);
  private logService = inject(LogService);

  constructor(
    private ngxAppleLoginService: NgxAppleLoginService,
    private historyEventService: HistoryEventService,
    private router: Router
  ) {
    this.initConfiguration();
  }

  initConfiguration() {
  }

  login() {
    var token = this.accountService.getAccessToken();
    if (this.accountService.isAuthSourceGoogle() || token.length == 0) {
      this.ngxAppleLoginService.signIn(appleAuthConfig).then((res) => {
        this.accountService.getAccountTokenApple(res.authorization.code, res.authorization.id_token)
          .subscribe(
            {
              next: (data) => {
                if (data.accountId != '-1') {
                  this.accountService.checkProfileAndSetInfo(data, AuthSourceApple);
                }
                else {
                  this.router.navigate(['noaccount']);
                }
              },
              error: (e) => {
                this.accountService.authSendError('', JSON.stringify(e), 'AppleAuth');
                this.router.navigate(['']);
              }
            }
          );
      }).catch((error) => {
        this.accountService.authSendError('', JSON.stringify(error), 'AppleAuth');
        this.logService.LogMessage(JSON.stringify(error));
      })
    }
    else {
      this.historyEventService.setEvent('account');
      this.router.navigate(["/main"]);
    }
  }

  logout() {
  }
}
